import {ProductTileEntities} from './types';

export const isProductTileEntities = (
  entities: ProductTileEntities | {[key: string]: unknown},
): entities is ProductTileEntities => {
  return Boolean(entities?.badges && entities?.brand && entities?.product);
};
